export default "__VITE_ASSET__kl7mKqmF__"